import { useSearchParams } from 'react-router';

export function useSiteScope(): { siteId: string | undefined; setSiteId: (id: string | undefined) => void } {
  const [params, setParams] = useSearchParams();
  const siteId = params.get('site') ?? undefined;
  return {
    siteId,
    setSiteId: (id) =>
      setParams((p) => {
        const next = new URLSearchParams(p);
        if (id) next.set('site', id);
        else next.delete('site');
        return next;
      }),
  };
}
